module.exports = __webpack_public_path__ + "img/13.6bb510c3.png";